import { Flex, Text } from '@chakra-ui/react'
import Card from '../Card/Card'
import CardBody from '../Card/CardBody'
import CardFooter from '../Card/CardFooter'
import CardHeader from '../Card/CardHeader'

interface Props {
    title: string,
    noData?: boolean,
    footer?: string,
    children: React.ReactNode
}

const ChartBox = ({ title, footer, noData = false, children }: Props) => {
    return (
        <Card minH="370px" px="22px">
            <CardHeader>
                {title}
            </CardHeader>
            <CardBody h="100%">
                {
                    !noData ?
                        children
                        :
                        <Flex w="full" h="full" justifyContent="center" alignItems="center">
                            <Text fontSize="xl" fontWeight="bold">N/A</Text>
                        </Flex>
                }
            </CardBody>
            <CardFooter>
                {footer}
            </CardFooter>
        </Card>
    )
}

export default ChartBox